module.exports = __webpack_public_path__ + "img/1+1-Tafel_Verdopplung.0e7c49ff.png";